import { createListenerMiddleware } from '@reduxjs/toolkit';
import type { TypedStartListening } from '@reduxjs/toolkit';
import type { RootState, AppDispatch } from '../store';
import { updateCalculation, getTotalThunk, saveDraftThunk, getTotalSettled } from '../slices/calculation';

export const calculationListenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
const startAppListening = calculationListenerMiddleware.startListening as AppStartListening;

startAppListening({
  actionCreator: updateCalculation,
  effect: async (action, api) => {
    const { principal, tenor, promoCode, tenors } = action.payload;
    if (principal == null || tenor == null || !tenors?.length) {
      return;
    }
    const state = api.getState();
    const { appliedPromoCode, promoCode: statePromoCode } = state.calculation;
    const promoCodeToSend = promoCode !== undefined ? promoCode : appliedPromoCode ?? statePromoCode ?? null;
    const result = await api.dispatch(
      getTotalThunk({
        principal,
        tenor,
        promoCode: promoCodeToSend,
        tenors,
      }),
    );
    api.dispatch(getTotalSettled());
    if (getTotalThunk.fulfilled.match(result)) {
      await api.dispatch(saveDraftThunk());
    }
  },
});
